import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import {
  makeGetCardTitle,
  makeGetLearnMoreUrl,
  makeGetLearnMoreDtm
} from '../redux';

import removeTags from 'service_modules/utils/text-remove-tags';
import {
  sendDTMClickEvent,
  mapUrlWithDtmLinkQuery
} from 'service_modules/models/dtm-tagging';

import { Type, Button } from '@americanexpress/aqx-components';

import styles from '../__styles__/ctas.scss?modules';

const LearnMoreCta = ({
  cardTitle,
  learnMoreUrl,
  shortName,
  learnMoreDtm,
  isBottomRow
}) => {
  const text = 'Learn More';
  const url = mapUrlWithDtmLinkQuery(learnMoreUrl, learnMoreDtm);
  const onClick = useCallback(
    () => {
      sendDTMClickEvent({
        eventAction: 'Click',
        eventType: 'pageInteraction',
        eventAsset: `learn-more_${shortName}`
      });
    },
    [shortName]
  );
  return (
    <Button
      Component="a"
      $type={Type.Secondary}
      title={text}
      aria-label={removeTags(`${text} about ${cardTitle}`)}
      href={url}
      onClick={onClick}
      className={clsx(styles.learnMoreCta, {
        [styles.bottomRow]: isBottomRow
      })}
    >
      {text}
    </Button>
  );
};

const mapStateToProps = () => {
  const getCardTitle = makeGetCardTitle();
  const getLearnMoreDtm = makeGetLearnMoreDtm();
  const getLearnMoreUrl = makeGetLearnMoreUrl();

  return (state, { shortName }) => ({
    cardTitle: getCardTitle(state, shortName),
    learnMoreUrl: getLearnMoreUrl(state, shortName),
    learnMoreDtm: getLearnMoreDtm(state, shortName)
  });
};

export default connect(mapStateToProps)(LearnMoreCta);
